// extracted by mini-css-extract-plugin
module.exports = {"logo":"old-logo_logo__aVLBL"};